import React from 'react';
import { Countdown } from './Shared';
export const UrgencySection = () => {
  return <section id="precio-lanzamiento" className="bg-megapack-bg border-t border-megapack-cyan/30 py-10 md:py-16 px-4 md:px-6" data-id="element-230">
      <div className="max-w-4xl mx-auto text-center w-[92%] md:w-full" data-id="element-231">
        <h2 className="text-megapack-red font-bold text-base sm:text-xl md:text-2xl mb-8 md:mb-12 animate-blink uppercase tracking-widest text-center" data-id="element-232">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <Countdown className="mb-8 md:mb-12" data-id="element-233" />

        <p className="text-megapack-gray text-[15px] md:text-lg mb-8 md:mb-12 text-center" data-id="element-234">
          Después sube y no vuelve a bajar.
        </p>

        <div className="max-w-md mx-auto bg-megapack-card border border-megapack-cyan/20 p-4 md:p-6 rounded-2xl" data-id="element-235">
          <div className="flex justify-between items-center mb-4" data-id="element-236">
            <div className="flex items-center gap-2" data-id="element-237">
              <span className="w-2 h-2 bg-megapack-red rounded-full animate-ping" data-id="element-238" />
              <span className="text-sm font-bold" data-id="element-239">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-megapack-red font-bold text-sm" data-id="element-240">
              Quedan pocos
            </span>
          </div>
          <div className="w-full bg-white/5 h-3 rounded-full overflow-hidden" data-id="element-241">
            <div className="bg-megapack-cyan h-full w-[15%]" data-id="element-242" />
          </div>
        </div>
      </div>
    </section>;
};